import { Col, useTheme } from "@commonlibs";
import HelpItem from "ui/common/components/display/HelpItem/HelpItem";
import { useHelpFindAll } from "features/faqs/hooks/useHelpFindAll";

function HelpList() {
    const { data } = useHelpFindAll();
    const { spacing } = useTheme();
    return (
        <Col gap={spacing[4]}>
            {data?.map((faq, index) => (
                <HelpItem
                    faq={faq}
                    // skipcq
                    key={index}
                />
            ))}
        </Col>
    );
}

export default HelpList;
